import { Location } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { cnpj } from 'cpf-cnpj-validator';
import { Subscription } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { Items } from 'src/app/services/EmpresaService/empresa.model';
import { EmpresaService } from 'src/app/services/EmpresaService/empresa.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import { ViaCepService } from 'src/app/services/ViaCep/viacep.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-cadastro-empresa',
  templateUrl: './cadastro-empresa.component.html',
  styleUrls: ['./cadastro-empresa.component.scss']
})
export class CadastroEmpresaComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private subscription$ = new Subscription();
  private empresaService = inject(EmpresaService);
  private viaCepService = inject(ViaCepService);
  form = this._inicializarFormulario();
  activeRoute: string = '';
  isLoading: boolean = false;
  isLengthValid = false;
  hasNumber = false;
  hasLowercase = false;
  hasUppercase = false;
  hasSpecialChar = false;
  passwordsMatch = false;
  isValid = false;
  pkEmpresa: number = 0;
  guid = generateUUID();

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private cd: ChangeDetectorRef,
    private location: Location,
    private swalAlert: SwalAlertService
  ) {}

  ngOnInit(): void {
    this.form.reset();
    this.form.valueChanges.subscribe(() => {
      this.isValid = this.form.valid;
    });
  }

  ngAfterViewInit(): void {
    if (!this.isMode()) {
      const id = Number(localStorage.getItem('id'));
      this.empresaService.GetEmpresaById(id).subscribe((response: Items) => {
        this.pkEmpresa = response.PK_EPSA;
        this.form.controls['NM_FNTS_EPSA'].setValue(response.NM_FNTS_EPSA);
        this.form.controls['NM_RESP_OPRC_EPSA'].setValue(
          response.NM_RESP_OPRC_EPSA
        );
        this.form.controls['NM_RZAO_SOCI_EPSA'].setValue(
          response.NM_RZAO_SOCI_EPSA
        );
        this.form.controls['NU_TELE_EPSA'].setValue(response.NU_TELE_EPSA);
        this.form.controls['NU_TELE_OPRC_EPSA'].setValue(
          response.NU_TELE_OPRC_EPSA
        );
        this.form.controls['TX_CNPJ_EPSA'].setValue(response.TX_CNPJ_EPSA);
        this.form.controls['TX_ENDE_CDDE_EPSA'].setValue(
          response.TX_ENDE_CDDE_EPSA
        );
        this.form.controls['TX_ENDE_CEP_EPSA'].setValue(
          response.TX_ENDE_CEP_EPSA
        );
        this.form.controls['TX_ENDE_ESTD_EPSA'].setValue(
          response.TX_ENDE_ESTD_EPSA
        );
        this.form.controls['TX_INCR_ESTD_EPSA'].setValue(
          response.TX_INCR_ESTD_EPSA
        );
        this.form.controls['TX_MAIL_EPSA'].setValue(response.TX_MAIL_EPSA);
      });
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  private _inicializarFormulario() {
    const form = this.fb.group(
      {
        TX_CNPJ_EPSA: ['', Validators.required],
        NM_RZAO_SOCI_EPSA: [
          '',
          [Validators.required, Validators.pattern('^[a-zA-ZÀ-ÿ0-9\\s.]*$')]
        ],
        NM_FNTS_EPSA: ['', Validators.required],
        NU_TELE_EPSA: ['', Validators.required],
        TX_INCR_ESTD_EPSA: [''],
        NU_TELE_OPRC_EPSA: ['', Validators.required],
        NM_RESP_OPRC_EPSA: ['', Validators.required],
        TX_MAIL_EPSA: [
          '',
          [
            Validators.required,
            Validators.email,
            Validators.pattern(
              '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'
            )
          ]
        ],
        TX_ENDE_CEP_EPSA: ['', Validators.required],
        TX_ENDE_RUA_EPSA: ['', Validators.required],
        TX_ENDE_CDDE_EPSA: ['', Validators.required],
        TX_ENDE_ESTD_EPSA: ['', Validators.required],
        TX_SENH_EPSA: ['', Validators.required],
        TX_SENH_EPSA_CNFRM: ['', Validators.required]
      },
      { validator: this.passwordMatchValidator }
    );

    return form;
  }

  postarDados() {
    const body = this.form.getRawValue();
    if (this.form.valid) {
      if (!cnpj.isValid(String(this.form.controls['TX_CNPJ_EPSA'].value))) {
        this.swalAlert.showAlert(
          'Atenção!',
          'O CNPJ informado é inválido.',
          'warning',
          false,
          false,
          undefined
        );

        return;
      }

      this.isLoading = true;
      if (this.isValid) {
        if (this.isMode()) {
          this.empresaService.CreateEmpresa(body, this.guid).subscribe(
            response => {
              this.isLoading = false;
              this.router.navigate(['/']);
            },
            error => {
              this.isLoading = false;
            }
          );
        } else {
          this.empresaService.UpdateEmpresa(this.pkEmpresa, body).subscribe({
            next: response => {
              this.isLoading = false;
              this.router.navigate(['/home']);
            },
            error: error => {
              this.isLoading = false;
            }
          });
        }
      } else {
        this.isLoading = false;
        this.swalAlert.showAlert(
          'Atenção!',
          'A senha informada não conferem, verifique e tente novamente.',
          'warning',
          false,
          false,
          undefined
        );
      }
    } else {
      this.isLoading = false;
      this.swalAlert.showAlert(
        'Atenção!',
        'Preencha os campos obrigatórios para prosseguir com a operação.',
        'warning',
        false,
        false,
        undefined
      );
    }
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  consultaCEP() {
    const cep = String(this.form.controls['TX_ENDE_CEP_EPSA'].value);
    if (cep.length >= 8) {
      this.viaCepService.GetBuscarCep(cep).subscribe(response => {
        this.form.controls['TX_ENDE_CDDE_EPSA'].setValue(response.localidade);
        this.form.controls['TX_ENDE_ESTD_EPSA'].setValue(response.uf);
        this.form.controls['TX_ENDE_RUA_EPSA'].setValue(response.logradouro);
      });
    }
  }

  passwordMatchValidator(
    control: AbstractControl
  ): { [key: string]: boolean } | null {
    const password = control.get('TX_SENH_EPSA');
    const confirmPassword = control.get('TX_SENH_EPSA_CNFRM');
    if (
      password &&
      confirmPassword &&
      password.value !== confirmPassword.value
    ) {
      return { mismatch: true };
    }
    return null;
  }

  confirmacaoSenha() {
    const senha = this.form.get(['TX_SENH_EPSA'])?.value;
    const novaSenha = this.form.get(['TX_SENH_EPSA_CNFRM'])?.value;

    this.isLengthValid = senha.length >= 8;
    this.hasNumber = /\d/.test(senha);
    this.hasLowercase = /[a-z]/.test(senha);
    this.hasUppercase = /[A-Z]/.test(senha);
    this.hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(senha);
    this.passwordsMatch = senha === novaSenha;

    this.form.updateValueAndValidity();
  }

  isMode(): boolean {
    const mode = this.location.path();
    if (!mode.includes('edicao/empresa')) {
      return true;
    }
    this.isValid = true;
    this.form.controls['TX_SENH_EPSA'].clearValidators();
    this.form.controls['TX_SENH_EPSA_CNFRM'].clearValidators();

    return false;
  }

  onVoltar(): string {
    return '';
  }
}
